import { IBannerRequest } from '../../interfaces/Website/Banners/IBanners'
import apiService from '../Api'

// Os dois flags vão sempre como `1`/`0`. A API devolve `is_gradient_active` como booleano (cast
// do model), e `String(false)` no FormData chegava ao MySQL como o texto `'false'` — que o modo
// estrito de produção recusa numa coluna inteira (500). O banco local aceitava e gravava `0`.
const BOOLEAN_FIELDS = ['is_active', 'is_gradient_active'] as const

// As cores vão sempre, mesmo vazias: o "Limpar cor" do formulário deixa o campo em `''`, e o
// `ConvertEmptyStringsToNull` da API grava `null`. Omitir o campo também zerava, porque o `update`
// lê cada cor do request, mas só por acaso: um update parcial passaria a manter a cor antiga.
const COLOR_FIELDS = [
  'title_color',
  'subtitle_color',
  'tag_presencial_color',
  'tag_online_color',
  'tag_online_ao_vivo_color',
  'tag_presencial_text_color',
  'tag_online_text_color',
  'tag_online_ao_vivo_text_color',
  'button_text_color',
  'gradient_color',
  'button_color'
] as const

function bannerFormData(data: IBannerRequest): FormData {
  const formData = new FormData()
  Object.keys(data).forEach((key) => {
    if ((BOOLEAN_FIELDS as readonly string[]).includes(key)) return

    if ((COLOR_FIELDS as readonly string[]).includes(key)) {
      formData.append(key, (data as Record<string, string | null | undefined>)[key] ?? '')
      return
    }

    if ((data as Record<string, string | File>)[key]) {
      formData.append(key, (data as Record<string, string | File>)[key])
    }
  })

  BOOLEAN_FIELDS.forEach((field) => {
    if (data[field] !== undefined) {
      formData.append(field, data[field] ? '1' : '0')
    }
  })

  data.tags?.forEach((tag) => {
    formData.append('tags[]', tag)
  })

  return formData
}

export default class BannerService {
  async list() {
    return apiService.get('internal/website/banner').then(({ data }) => data)
  }

  async create(data: IBannerRequest) {
    const formData = bannerFormData(data)

    return apiService
      .post('internal/website/banner', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then(({ data }) => data)
  }

  async update(id: number, data: IBannerRequest) {
    const formData = bannerFormData(data)
    formData.append('_method', 'PUT')

    return apiService
      .post(`internal/website/banner/${id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then(({ data }) => data)
  }

  async reorder(order: number[]) {
    return apiService.put('internal/website/banner/reorder', { order }).then(({ data }) => data)
  }

  async delete(id: number) {
    return apiService.delete(`internal/website/banner/${id}`).then(({ data }) => data)
  }

  async enable(id: number) {
    return apiService.put(`internal/website/banner/enable/${id}`).then(({ data }) => data)
  }

  async disable(id: number) {
    return apiService.put(`internal/website/banner/disable/${id}`).then(({ data }) => data)
  }
}
